import { render, staticRenderFns } from "./Ponuda.vue?vue&type=template&id=2b639d6d&scoped=true&"
import script from "./Ponuda.vue?vue&type=script&lang=js&"
export * from "./Ponuda.vue?vue&type=script&lang=js&"
import style0 from "./Ponuda.vue?vue&type=style&index=0&id=2b639d6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b639d6d",
  null
  
)

export default component.exports